// extracted by mini-css-extract-plugin
module.exports = {"spacing-1":"spacing_spacing-1__Kx2JQ","spacing-2":"spacing_spacing-2__25rNl","spacing-3":"spacing_spacing-3__UVtJB","spacing-4":"spacing_spacing-4__syJDe"};